<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e7RB3A/OEBPS/images/9781443113144_Outside_Front_Cover.jpg?1692135101209" alt="This image is the cover for the book Dear Canada: Orphan at My Door, Dear Canada"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dear Canada: Orphan at My Door, Dear Canada
      </h1>
      <p class="bookDescription body article font2">
        <p>Through the diary of 10-year-old Victoria Cope, we learn about the arrival of ragged Mary Anna, one of the thousands of impoverished British children who were sent to Canada at the beginning of the century. Mary Anna joins the Cope family as a servant and is treated well, but she has to cope with the initial apprehension of the family members and the loss of her brother, Jasper, who was placed with another family. Victoria vows to help Mary Anna find her brother, so they can be a family once again.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean Little
      </h2>
      
      <p class="authorDescription body article">One of Canada's premier authors, <b>Jean Little</b>'s previous books include <i>Mama's Going to Buy You a Mockingbird</i> (CLA Book of the  Year and Ruth Schwartz Award-winner), <i>Listen for the Singing</i> (Canada Council Children's Literature Prize), and <i>Mine for Keeps</i> (Little Brown Canadian Children's Book Award). She received the Vicky Metcalf Award in 1974 for her body of work. Jean lives near Guelph, Ontario.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Demo
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a56b11a